import { BISNODE_SCORING_CHART_TOGGLE_DATA_TABLE } from './constants'

// eslint-disable-next-line
export function bisnodeScoringChartToggleDataTable(module, id, blockKey, customData) {
    return {
        type: BISNODE_SCORING_CHART_TOGGLE_DATA_TABLE,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}
